import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const field = "w-full bg-white border border-border-subtle px-4 py-3 text-charcoal text-[0.95rem] focus:border-navy outline-none transition-colors";

const AdminReset = () => {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 10) return toast.error("Password must be at least 10 characters.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset. Please sign in.");
      nav("/admin/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "#F7F4EE" }}>
      <div className="w-full max-w-md">
        <form onSubmit={submit} className="bg-white border border-border-subtle p-8" data-testid="admin-reset-form">
          <h1 className="font-serif text-navy text-3xl mb-2">Set a new password</h1>
          {!token && <p className="text-sm text-red-700 mb-4">Missing or invalid reset link.</p>}
          <label className="block text-xs font-semibold tracking-wider uppercase text-charcoal/70 mb-2 mt-4">New password</label>
          <input className={field} type="password" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="admin-reset-input" />
          <button type="submit" className="btn-solid mt-7 w-full justify-center" disabled={busy || !token} data-testid="admin-reset-submit">
            {busy ? <Loader2 size={16} className="animate-spin" /> : "Reset password"}
          </button>
        </form>
        <div className="text-center mt-6">
          <Link to="/admin/login" className="text-sm text-charcoal/50 hover:text-navy link-underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminReset;
